'use client';

import { singleProject } from '@/enteties/project/api';
import { useQuery } from '@tanstack/react-query';
import { Skeleton } from 'shared/ui/skeleton';
import { useOnError } from 'shared/hooks/useOnError';
export interface ProjectNameProps {
  slug: string;
}
export const ProjectName = ({
  slug
}: ProjectNameProps) => {
  const {
    data: projectName,
    isLoading,
    isError,
    error
  } = useQuery({
    ...singleProject.getSingleProjectQueryOptions({
      slug
    }),
    select: data => data.name
  });
  useOnError({
    isError,
    description: error?.message
  });
  if (isLoading) return <div className="h-3.5 flex items-center">
        <Skeleton className="h-3 w-32 rounded-full" variant="dark" />
      </div>;
  return <>{projectName}</>;
};